import { getRoot, types } from 'mobx-state-tree';
import { RootType } from '../../rootInstance';
import { HttpVerbs } from '../../constants/verbs';
import { ApiListResponse } from '../ApiModel';
import { BANNER_PAGE_SIZE } from '../../constants/banners';

export interface NewsletterApiType {
  id?: string;
  name?: string;
  status?: number;
  url?: string;
  showEveryTime?: number;
  dateStart?: string;
  dateEnd?: string;
  createdBy?: string;
  createdAt?: string;
}

export const NewsletterApi = types
  .model('NewsletterApi', {})
  .views((self) => {
    return {
      get root(): RootType {
        return getRoot(self);
      },
    };
  })
  .actions((self) => {
    return {
      async get(newsletterId: string): Promise<NewsletterApiType> {
        return await self.root.axios.requestData({
          type: HttpVerbs.GET,
          path: `/newsletters/${newsletterId}`,
        });
      },
      async getList(page: number): Promise<ApiListResponse<NewsletterApiType>> {
        return await self.root.axios.requestData({
          type: HttpVerbs.GET,
          path: `/newsletters?page=${page}&limit=${BANNER_PAGE_SIZE}`,
        });
      },
      async create(data: NewsletterApiType) {
        try {
          return await self.root.axios.requestData({
            type: HttpVerbs.POST,
            path: '/newsletters',
            data,
          });
        } catch (err) {
          self.root.showFailure('e400');
          throw err;
        }
      },
      async update(newsletterId: string, data: NewsletterApiType) {
        try {
          return await self.root.axios.requestData({
            type: HttpVerbs.PATCH,
            path: `/newsletters/${newsletterId}`,
            data,
          });
        } catch (err) {
          self.root.showFailure('e400');
          throw err;
        }
      },
      async delete(newsletterId: string) {
        try {
          return await self.root.axios.requestData({
            type: HttpVerbs.DELETE,
            path: `/newsletters/${newsletterId}`,
          });
        } catch (err) {
          self.root.showFailure('e400');
          throw err;
        }
      },
      async toggleActive(bannerId: string, isActive: boolean) {
        try {
          return await self.root.axios.requestData({
            type: HttpVerbs.PATCH,
            path: `/newsletters/${bannerId}`,
            data: { status: Number(isActive) },
          });
        } catch (err) {
          self.root.showFailure('e400');
          throw err;
        }
      },
    };
  });
